export const LOTS_STATUS = ['en preparation', 'en vente', 'option', 'pré-résa', 'réservé', 'rdv signature', 'vendu'];

export const isOutreMer = cp => {
  const tmp = parseInt(cp.substr(0, 3), 10);

  return tmp >= 971 && tmp <= 988;
};

/**
 * Function récupérée du site legacy en php : dbtools/rowLot_class.php:819
 * @param {Object} lot Lot sur lequel la surface fiscal est calculée
 * @returns {number} Surface fiscal
 */
export const calculSurfFiscale = lot => {
  let surfFiscale = 0;

  if (isOutreMer(lot.prog.cp)) {
    let annexe = 0;
    if (parseFloat(lot.surf_annexe_eligible)) {
      annexe = parseFloat(lot.surf_annexe_eligible);
    } else {
      annexe = parseFloat(lot.surf_balcon_loggia);
    }
    if (annexe > 14) {
      annexe = 14;
    }
    surfFiscale = parseFloat(lot.surf_hab || 0) + annexe;
  } else {
    let garage = 0;

    if (parseFloat(lot.surf_garage_inclus) > 12) {
      garage = parseFloat(lot.surf_garage_inclus) - 12;
    } else {
      garage = parseFloat(lot.surf_garage_inclus);
    }
    let cellier = parseFloat(lot.surf_cellier_ext_cave) || 0;
    let terrasse = parseFloat(lot.surf_annexe_eligible) || 0;
    if (terrasse > 9) {
      terrasse = 9;
    }
    let balcon = parseFloat(lot.surf_balcon_loggia) || 0;
    let annexe = (garage + cellier + terrasse + balcon) * 0.5;
    if (annexe > 8) {
      annexe = 8;
    }
    surfFiscale = parseFloat(lot.surf_hab || 0) + annexe;
  }

  return surfFiscale || 0;
};

/**
 * Function récupérée du site legacy en php : dbtools/rowLot_class.php:871
 * @param {Object} lot Lot sur lequel la surface fiscal est calculée
 * @returns {number} Surface utile
 */
export const calculSurfUtile = lot => {
  if (isOutreMer(lot.prog.cp)) {
    const balconGarageCellier =
      (parseFloat(lot.surf_terrasse) + parseFloat(lot.surf_garage_inclus) + parseFloat(lot.surf_cellier_ext_cave)) *
      0.5;

    return parseFloat(lot.surf_hab) + parseFloat(lot.surf_balcon_loggia) + balconGarageCellier || 0;
  } else {
    const balconGarageCellier =
      (parseFloat(lot.surf_balcon_loggia) +
        parseFloat(lot.surf_garage_inclus) +
        parseFloat(lot.surf_cellier_ext_cave)) *
      0.5;
    const terrasse = parseFloat(lot.surf_terrasse) * 0.33;

    return parseFloat(lot.surf_hab) + balconGarageCellier + terrasse || 0;
  }
};
